import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Document } from '../../document';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { DocumentsService } from '../../services/documents/documents.service';

@Component({
    selector: 'app-rename-chapter',
    templateUrl: './rename-document.component.html',
    styleUrls: ['./rename-document.component.scss'],
    standalone: false,
})
export class RenameDocumentComponent implements OnInit {
    public form: FormGroup;
    public saving = false;

    constructor(
        public dialogRef: MatDialogRef<RenameDocumentComponent>,
        private confirmDialogService: ConfirmDialogService,
        private libraryService: DocumentsService,
        @Inject(MAT_DIALOG_DATA) public chapter: Document
    ) {}

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl(this.chapter.name, [Validators.required, Validators.maxLength(255)]),
        });
    }

    save() {
        if (this.form.valid) {
            this.saving = true;
            this.chapter.name = this.form.get('name').value;
            this.libraryService
                .rename(this.chapter)
                .then(chapter => {
                    this.saving = false;
                    this.dialogRef.close(chapter);
                })
                .catch(() =>
                    this.confirmDialogService.confirm(
                        'Fout bij opslaan',
                        `Er is iets fout gegaan bij het opslaan`,
                        'Oké'
                    )
                );
        }
    }
}
